/**
 * @file Column component for displaying a entity value.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { AlertsService } from '../../../core/alerts.service';
import { OverlayService } from '../../../core/overlay.service';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Column component for displaying a entity value
 */
var ColumnEntityComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnEntityComponent, _super);
    /**
     * Constructs a ColumnEntityComponent.
     * @param provider Provides the configuration information for the column.
     * @param overlayService The router service.
     */
    function ColumnEntityComponent(provider, changeDetector, overlayService, alertsService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.overlayService = overlayService;
        _this.alertsService = alertsService;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnEntityComponent.register = function () {
        ComponentRegistry.register('column', 'entity', ColumnEntityComponent);
    };
    /**
     * Go to given entity in the app
     * @param entity The entity to open
     */
    ColumnEntityComponent.prototype.goToEntity = function ($event) {
        // Stop event bubbling (and prevent opening of the edit form)
        $event.stopPropagation();
        // Go to entity
        if (!this.overlayService.goToEntity(this.provider.entity)) {
            this.alertsService.createAlert('warning', 'APP.LISTS.CAN_NOT_GO_TO_ENTITY');
        }
    };
    /**
     * Returns a string representation of the entity based on the field settings.
     * @returns {string} A string representation of the entity.
     */
    ColumnEntityComponent.prototype.getDisplayValue = function () {
        var _this = this;
        if (!this.provider.field.format) {
            console.warn('Field format is missing for column entity.');
            return '';
        }
        if (!this.provider.field.format['fields']) {
            console.warn('Fields in field format is missing for column entity.');
            return '';
        }
        var result = '';
        this.provider.field.format.fields.forEach(function (field) {
            if (result !== '') {
                result += ' ';
            }
            result += _this.provider.value[field];
        });
        return result;
    };
    return ColumnEntityComponent;
}(ColumnBase));
export { ColumnEntityComponent };
